var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import z from 'zod';
export var createAnalyticsSchema = function (shape) {
    return z.object(__assign({ sessionId: z.string(), source: z.object({
            hostname: z.string(),
            origin: z.string(),
        }), name: z.string().optional(), timestamp: z.number().default(function () { return Date.now() / 1000; }) }, shape));
};
export var createCustomAnalyticsSchema = createAnalyticsSchema({}).catchall(z.any());
